import {AjaxDataTypes} from '../../../../shared/AjaxDataTypes.ts'
import {UIAjaxWrapper} from '../network/UIAjaxWrapper.ts'
import {UIAPIEndpoints} from '../network/UIAPIEndpoints.ts'
import {UIUtilsEjsVariables} from '../UIUtilsEjsVariables.ts'

export async function getColonistUsername(originalUsername: string, userId: string | undefined) {
    if(!UIUtilsEjsVariables.isUserOnDiscord) return originalUsername

    if(userId == undefined) return originalUsername
    const response = await UIAjaxWrapper.getRequestHandler(UIAPIEndpoints.apiUserProfile.username(userId), undefined)
    if(response == undefined) return originalUsername

    const responseData = response.json as AjaxDataTypes.UsernameResponse
    return responseData.username ?? originalUsername
}
